module.exports = __webpack_public_path__ + "e3212672b56217c42c6eb13c5154d48c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mgm-bg-1.jpg
// module id = 140
// module chunks = 0